export default __webpack_public_path__ + "static/media/level_star_02.de92d112.svg";